module.exports = __webpack_public_path__ + "img/Maria_Montanio.f3f3cf7b.jpg";